import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-24cac6b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import axios from "axios";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'new-solo-button',
  setup(__props) {

const isButtonDisabled = ref(false);
const onCreateNewSoloClick = async () => {
  isButtonDisabled.value = true;
  const { request } = await axios.post("/review/reviewyourselfagain");
  if (request?.responseURL.length > 0) {
    window.location.href = request.responseURL;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-repeat-strengths-mapping mt-1",
    onClick: onCreateNewSoloClick,
    disabled: isButtonDisabled.value,
    "data-test": "create-new-solo-button"
  }, " Create new solo report ", 8, _hoisted_1))
}
}

})